
import React, { useState } from "react";
import { Box, Fab, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { red } from "@mui/material/colors";
import { TablaCotizacionSinEditar } from "./TablaCotizacionSinEditar";
import { TablaCotizacionEditar } from "./TablaCotizacionEditar";
import { LayoutTabla } from "../../layouts";
import { useAuthStore, useUsuariosStore } from "../../../stores";
import { iconos, rolesdeEdicion } from "../../../data";

import Swal from "sweetalert2";




export const TablaCotizacionCliente = ({ data }) => {


    const { usuario } = useAuthStore();
    const { usuarioVenta } = useUsuariosStore();
    const [selected, setSelected] = useState([]);
    


    const handleSelectAllClick = ( event ) => {
        if (event.target.checked) {
            const newSelected = data.map( (p) => p.id );
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };



    const handleClick = (name) => {
        (selected.some((item) => item === name)) 
        ?   setSelected((prevSelected) => prevSelected.filter((item) => item !== name))
        :   setSelected((prevSelected) => [...prevSelected, name])
    };



    const  eliminarMultiple = async () => {
        const resp = await Swal.fire({
            title: ( selected.length > 1 ) ? 'Eliminar Items' : 'Eliminar Item',
            text: ( selected.length > 1 ) ? `¿Esta Seguro De Eliminar Estos Items?` : `¿Esta Seguro De Eliminar Este Item?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si, Eliminar' 
        });
        if(resp.value){
            // const result = await dispatch(carritoDeleteMultiple( selected ));
            // if( result ) {
            //     setSelected([]);
            // }
        }
    }



    return (

        <>
        <LayoutTabla mb={2}>
            <TableHead>
                <TableRow>
                    <TableCell sx={{width:'20%'}}>NIT/CEDULA</TableCell>
                    <TableCell sx={{width:'40%'}}>CLIENTE</TableCell>
                    <TableCell sx={{width:'20%'}}>CELULAR</TableCell>
                    <TableCell sx={{width:'20%'}}>CIUDAD</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                <TableRow>
                    <TableCell>{usuarioVenta.cedula}</TableCell>
                    <TableCell>{usuarioVenta.nombre}</TableCell>
                    <TableCell>{usuarioVenta.movil}</TableCell>
                    <TableCell>{usuarioVenta.ciudad}</TableCell>
                </TableRow>
            </TableBody>
        </LayoutTabla>

        <LayoutTabla>
            <TableHead>
                <TableRow >
                    <TableCell padding="checkbox">
                        {/* <Checkbox
                            color="secondary"
                            indeterminate={ selected.length > 0 && selected.length < data.length }
                            checked={ data.length > 0 &&  selected.length === data.length }
                            onChange={ handleSelectAllClick }
                        /> */}
                        #
                    </TableCell>
                    <TableCell sx={{width:'17%'}}>PRODUCTO</TableCell>
                    <TableCell sx={{width:'30%'}}>DESCRIPCIÓN</TableCell>
                    <TableCell sx={{width:'16%'}}>CANTIDAD</TableCell>
                    <TableCell sx={{width:'17%'}}>PRECIO UNI.</TableCell>
                    <TableCell sx={{width:'20%'}}>PRECIO TOTAL</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {(rolesdeEdicion.includes(usuario.role) )
                ? <TablaCotizacionEditar data={data} selected={selected} handleClick={handleClick} />
                : <TablaCotizacionSinEditar data={data} selected={selected} handleClick={handleClick} />
                }
            </TableBody>
        </LayoutTabla>



        {(selected.length > 0) &&
        <Box sx={{ position:'fixed', bottom:20, right:20, zIndex:9999 }} >
            <Fab sx={{ bgcolor:red[500] }} onClick={ eliminarMultiple }>
                { React.cloneElement(iconos['eliminar'], {sx:{fontSize:35, color:'white'}})}
            </Fab>
        </Box>
        }
        </>
    )
}
